import type { ArrowStyleType } from '@octopus-do/octopus-project-core'
import {
  thunkChangeArrowColor,
  thunkChangeArrowType,
  thunkDeleteSelectedArrowGridPoint,
  thunkDeleteSelectedArrowLabel,
  thunkDeleteSelectedArrows,
} from '@store/migrationActions/thunkActions/thunkArrowsActions'
import {
  artBoardActions,
  selectSelectedArrowLabel,
} from '@store/reducers/artboard'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { notificationActionCreators } from '@storeOld/reducers/notification'
import { useDispatch, useSelector } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import type { AppState } from '@/types'

export const useArrowActions = (id: string) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()
  const labelSelected = useSelector(selectSelectedArrowLabel) === id

  const onChangeType = (type: ArrowStyleType) => {
    if (type === 'smooth') {
      dispatch(notificationActionCreators.setClearAllNotification())
    }

    dispatch(thunkChangeArrowType({ id, type }))
  }

  const onChangeColor = (colorId: string) =>
    dispatch(thunkChangeArrowColor({ colorId, id }))

  const onDeletePoint = () => dispatch(thunkDeleteSelectedArrowGridPoint())

  // The same as the Delete key: a selected label goes, and the arrow stays.
  const onDelete = () =>
    dispatch(
      labelSelected
        ? thunkDeleteSelectedArrowLabel()
        : thunkDeleteSelectedArrows()
    )

  const onEditLabel = () => {
    dispatch({ type: CanvasActionTypes.RESET_SELECTED_ARROW_ID })
    dispatch(artBoardActions.setEditingArrowLabel(id))
  }

  return {
    labelSelected,
    onChangeColor,
    onChangeType,
    onDeletePoint,
    onDelete,
    onEditLabel,
  }
}
